import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Plus, ClipboardList, UserCircle } from "lucide-react";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { api } from "@/lib/api";

export default function AgentLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [company, setCompany] = useState(null);
  useEffect(() => { api.get("/company").then((r) => setCompany(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="agent-layout">
      <header className="sticky top-0 z-20 bg-slate-950 text-slate-100 border-b border-slate-800">
        <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between gap-3">
          <NavLink to="/agent" className="flex items-center gap-2" data-testid="agent-home-link">
            <img src="/rozfa-logo-white.png" alt="Rozfa Print Ops" className="h-7 w-auto" />
            <div className="leading-tight border-l border-slate-700 pl-3">
              <div className="font-display font-bold text-sm">Agent Portal</div>
              <div className="text-[10px] font-mono text-slate-400">{user?.name} {user?.company ? `• ${user.company}` : ""}</div>
            </div>
          </NavLink>
          <nav className="flex items-center gap-1">
            <NavLink to="/agent" end className={({ isActive }) => `px-3 py-1.5 rounded text-sm flex items-center gap-1 ${isActive ? "bg-slate-800" : "hover:bg-slate-800/60"}`} data-testid="agent-nav-jobs"><ClipboardList className="w-4 h-4" /> My Jobs</NavLink>
            <NavLink to="/agent/profile" className={({ isActive }) => `px-3 py-1.5 rounded text-sm flex items-center gap-1 ${isActive ? "bg-slate-800" : "hover:bg-slate-800/60"}`} data-testid="agent-nav-profile"><UserCircle className="w-4 h-4" /> Profile</NavLink>
            <Button size="sm" onClick={() => nav("/agent/new")} className="bg-amber-400 hover:bg-amber-300 text-slate-950 font-semibold" data-testid="agent-nav-new"><Plus className="w-4 h-4 mr-1" /> New Order</Button>
            {company?.whatsapp && <WhatsAppButton phone={company.whatsapp} message={`Hi Rozfa Printing, I'm ${user?.name}${user?.company ? ` from ${user.company}` : ""} (Agent).`} label="Chat Rozfa" testid="agent-wa-rozfa" />}
            <Button size="sm" variant="ghost" onClick={async () => { await logout(); nav("/agent/login"); }} className="text-slate-300" data-testid="agent-logout"><LogOut className="w-4 h-4" /></Button>
          </nav>
        </div>
      </header>
      <main className="max-w-5xl mx-auto p-4 md:p-6"><Outlet /></main>
    </div>
  );
}
